var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 196,
    viewBox: "0 0 245 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 196C152.124 196 196 152.124 196 98C196 43.8761 152.124 0 98 0C43.8761 0 0 43.8761 0 98C0 152.124 43.8761 196 98 196Z",
    fill: "url(#paint0_linear_1249_34528)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1249_34528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5736 44.4266H229.974C231.706 44.4266 233.368 45.115 234.593 46.3402C235.819 47.5654 236.507 49.2272 236.507 50.96V83.6266C236.507 85.3594 235.819 87.0212 234.593 88.2464C233.368 89.4716 231.706 90.16 229.974 90.16H53.5736C51.8409 90.16 50.1791 89.4716 48.9539 88.2464C47.7286 87.0212 47.0403 85.3594 47.0403 83.6266V50.96C47.0403 49.2272 47.7286 47.5654 48.9539 46.3402C50.1791 45.115 51.8409 44.4266 53.5736 44.4266V44.4266Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.2 54.8799H103.227C101.062 54.8799 99.3069 56.635 99.3069 58.7999C99.3069 60.9649 101.062 62.7199 103.227 62.7199H137.2C139.365 62.7199 141.12 60.9649 141.12 58.7999C141.12 56.635 139.365 54.8799 137.2 54.8799Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.72 71.8666H103.227C101.062 71.8666 99.3069 73.6216 99.3069 75.7866C99.3069 77.9515 101.062 79.7066 103.227 79.7066H160.72C162.885 79.7066 164.64 77.9515 164.64 75.7866C164.64 73.6216 162.885 71.8666 160.72 71.8666Z",
    fill: "#DEE9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8538 67.2933C88.8538 56.8293 80.3711 48.3466 69.9071 48.3466C59.4432 48.3466 50.9604 56.8293 50.9604 67.2933C50.9604 77.7572 59.4432 86.24 69.9071 86.24C80.3711 86.24 88.8538 77.7572 88.8538 67.2933Z",
    fill: "#1485FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0005 69.6483C61.0005 71.3719 62.5394 72.88 64.74 72.88C66.756 72.88 68.1871 71.695 68.3564 70.033C68.5257 68.4941 67.6485 67.3092 65.4941 66.7398L64.1398 66.3859C62.8779 66.0627 62.7241 65.4164 62.7241 65.0008C62.7241 64.1391 63.5704 63.5389 64.5553 63.5389C65.6633 63.5389 66.402 64.1545 66.402 65.1393H68.0332C68.0332 63.2003 66.5559 62 64.5861 62C62.7241 62 61.0928 63.2157 61.0928 65.0316C61.0928 65.9704 61.4468 67.263 63.7243 67.8786L65.0632 68.2171C66.0481 68.448 66.8021 68.9558 66.7406 69.9407C66.6328 70.7255 65.9865 71.3873 64.74 71.3873C63.4627 71.3873 62.6779 70.5101 62.6317 69.6483H61.0005Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0839 63.6466H74.5769C76.6544 63.6466 77.7163 65.3548 77.7163 67.4477C77.7163 69.556 76.6544 71.218 74.5769 71.218H72.0839V63.6466ZM74.5769 72.7261C77.5932 72.7261 79.3475 70.4639 79.3475 67.4477C79.3475 64.4315 77.5932 62.1231 74.5769 62.1231H70.4527V72.7261H74.5769Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1249_34528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.374 103.227H33.9738C30.3655 103.227 27.4404 106.152 27.4404 109.76V142.427C27.4404 146.035 30.3655 148.96 33.9738 148.96H210.374C213.982 148.96 216.907 146.035 216.907 142.427V109.76C216.907 106.152 213.982 103.227 210.374 103.227Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.601 113.68H83.6273C81.4623 113.68 79.7073 115.435 79.7073 117.6C79.7073 119.765 81.4623 121.52 83.6273 121.52H117.601C119.766 121.52 121.521 119.765 121.521 117.6C121.521 115.435 119.766 113.68 117.601 113.68Z",
    fill: "#B4DAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.121 130.667H83.6275C81.4626 130.667 79.7075 132.422 79.7075 134.587C79.7075 136.752 81.4626 138.507 83.6275 138.507H141.121C143.286 138.507 145.041 136.752 145.041 134.587C145.041 132.422 143.286 130.667 141.121 130.667Z",
    fill: "#DEE9FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2539 126.093C69.2539 115.629 60.7712 107.147 50.3073 107.147C39.8433 107.147 31.3606 115.629 31.3606 126.093C31.3606 136.557 39.8433 145.04 50.3073 145.04C60.7712 145.04 69.2539 136.557 69.2539 126.093Z",
    fill: "#1485FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.311 134.231C46.8659 134.231 47.8322 132.544 47.8322 130.546V119.131H46.1453V130.546C46.1453 131.66 45.6376 132.61 44.311 132.61C44.1799 132.61 43.4429 132.577 43.1645 132.479L43.0007 134.051C43.4266 134.149 43.9998 134.231 44.311 134.231Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1847 130.579C56.4612 130.579 58.0007 129.089 58.0007 127.205C58.0007 125.551 56.8052 124.519 54.9053 124.044L53.4805 123.684C52.0556 123.324 51.941 122.57 51.941 122.21C51.941 121.178 52.8909 120.54 53.9554 120.54C55.1182 120.54 55.9535 121.26 55.9535 122.325H57.624C57.624 120.277 56.0354 119 54.0046 119C52.0065 119 50.254 120.261 50.254 122.243C50.254 123.176 50.6471 124.601 53.0546 125.207L54.4959 125.567C55.413 125.813 56.3138 126.288 56.3138 127.287C56.3138 128.221 55.5277 129.04 54.1847 129.04C52.7762 129.04 51.8754 128.106 51.8427 127.14H50.1722C50.1722 128.958 51.7772 130.579 54.1847 130.579Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1249_34528",
    x: 39.2003,
    y: 40.5066,
    width: 205.147,
    height: 61.4133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1249_34528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1249_34528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1249_34528",
    x: 19.6004,
    y: 99.3066,
    width: 205.147,
    height: 61.4133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1249_34528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1249_34528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1249_34528",
    x1: 98,
    y1: 0,
    x2: 98,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NOData.6a5e293e385cc5be12650f36c70700e9.svg";
export { ForwardRef as ReactComponent };